// extracted by mini-css-extract-plugin
export var content = "book-showcase-module--content--98ujv";
export var core = "book-showcase-module--core--3Yo8i";
export var cta = "book-showcase-module--cta--Y8F29";
export var ctaIcon = "book-showcase-module--ctaIcon--kxg3d";
export var description = "book-showcase-module--description--BQWZv";
export var details = "book-showcase-module--details--To9W0";
export var period = "book-showcase-module--period--o1XGq";
export var shell = "book-showcase-module--shell--p8Y5v";
export var topline = "book-showcase-module--topline--BKUK1";
export var visual = "book-showcase-module--visual--M2jML";